// Admin Configuration
// Change this route to make it more secure and unpredictable
export const ADMIN_ROUTE = '/syrdevuae-admin-panel-2024-secure';

// You can change this to any unpredictable route, for example:
// export const ADMIN_ROUTE = '/x7k9m2n4p8q1r3s5t6u7v8w9x0y1z2';
// export const ADMIN_ROUTE = '/admin-dashboard-secure-2024-syrdevuae';
// export const ADMIN_ROUTE = '/management-panel-syrdevuae-2024';

// Admin emails (update these as needed)
export const ADMIN_EMAILS = [
  'admin@syrdevuae.com',
]; 